import { render } from "./TransactionRow.vue?vue&type=template&id=0a449018&scoped=true"
import script from "./TransactionRow.vue?vue&type=script&lang=js"
export * from "./TransactionRow.vue?vue&type=script&lang=js"

import "./TransactionRow.vue?vue&type=style&index=0&id=0a449018&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a449018"]])

export default __exports__